// extracted by mini-css-extract-plugin
export default {"banner-spot":"styles_banner-spot__Uyx60","banner-img":"styles_banner-img__CFYl8","img-fluid":"styles_img-fluid__P+V1b","clearfix":"styles_clearfix__tPQ1y"};